export default __webpack_public_path__ + "static/media/tim-beiko.d125a04a.jpeg";